import React, { useRef, useState, useEffect } from "react";
import { Typography, Row, Col, Card, Grid } from "antd";
import Reveal from "../../common/Reveal";
import "./porqueescolher.css";

const { Title, Paragraph } = Typography;
const { useBreakpoint } = Grid;

function PorqueEscolher() {
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const cards = [
    {
      video: "/videos/corOuro.mp4",
      title: "Brilho uniforme",
      description: "Peças com brilho padronizado e aparência premium.",
      delay: 200,
    },
    {
      video: "/videos/qualidade.mp4",
      title: "Acabamento premium",
      description: "Detalhes valorizados com mais refinamento visual.",
      delay: 400,
    },
    {
      video: "/videos/organ.mp4",
      title: "Controle de qualidade",
      description: "Processo técnico com atenção em cada etapa.",
      delay: 600,
    },
    {
      video: "/videos/aten.mp4",
      title: "Atendimento especializado",
      description: "Suporte preparado para marcas e fabricantes.",
      delay: 800,
    },
  ];

  return (
    <section
      style={{
        padding: isMobile ? "56px 16px" : "72px 24px",
        background: "#fff",
      }}
    >
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <Reveal>
          <Title level={2} style={{ textAlign: "center", marginBottom: 12 }}>
            Por que escolher nosso Banho de Ouro?
          </Title>
        </Reveal>

        <Reveal delay={120}>
          <Paragraph
            style={{
              textAlign: "center",
              maxWidth: 760,
              margin: "0 auto 40px",
              fontSize: 16,
              color: "#666",
            }}
          >
            Cada detalhe do nosso processo é pensado para entregar brilho,
            acabamento e percepção premium para suas peças.
          </Paragraph>
        </Reveal>

        {isMobile ? (
          <div
            style={{
              display: "flex",
              gap: 16,
              overflowX: "auto",
              paddingBottom: 8,
              paddingRight: 24,
              scrollSnapType: "x mandatory",
              WebkitOverflowScrolling: "touch",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
            className="porque-escolher-mobile-scroll"
          >
            {cards.map((item) => (
              <div
                key={item.title}
                style={{
                  flex: "0 0 78%",
                  scrollSnapAlign: "start",
                }}
              >
                <Reveal delay={item.delay}>
                  <Card style={cardStyle}>
                    <VideoBox video={item.video} />
                    <Title level={4}>{item.title}</Title>
                    <Paragraph>{item.description}</Paragraph>
                  </Card>
                </Reveal>
              </div>
            ))}
          </div>
        ) : (
          <Row gutter={[24, 24]}>
            {cards.map((item) => (
              <Col xs={12} lg={6} key={item.title}>
                <Reveal delay={item.delay}>
                  <Card style={cardStyle}>
                    <VideoBox video={item.video} />
                    <Title level={4}>{item.title}</Title>
                    <Paragraph>{item.description}</Paragraph>
                  </Card>
                </Reveal>
              </Col>
            ))}
          </Row>
        )}
      </div>
    </section>
  );
}

/* COMPONENTE DE VIDEO */
function VideoBox({ video }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      style={{
        borderRadius: 12,
        overflow: "hidden",
        marginBottom: 16,
        background: "#f5f5f5",
        aspectRatio: "4 / 5",
      }}
    >
      {visible ? (
        <video
          src={video}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />
      ) : (
        <div style={loadingStyle}>Carregando...</div>
      )}
    </div>
  );
}

const cardStyle = {
  borderRadius: 16,
  overflow: "hidden",
  height: "100%",
};

const loadingStyle = {
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 12,
  color: "#999",
};

export default PorqueEscolher;